import { ThemeColor } from '@adaptiva/core/themes';
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
	selector: 'ada-ellipsis',
	templateUrl: './ellipsis.component.html',
	styleUrls: ['./ellipsis.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EllipsisComponent {

	protected readonly dotColor: InputSignal<ThemeColor> = input('foreground');

	protected readonly dotOpacity: InputSignal<float> = input(0.5);

	protected readonly dotSizePx: InputSignal<int> = input(12);

	protected readonly scale: float = 5;

	protected readonly interval: int[] = [1, 2, 3, 4];

}
